// extracted by mini-css-extract-plugin
export default {"list":"NavList_list__PxxHU"};